import { render } from "./icon-components.vue?vue&type=template&id=79febd48"
import script from "./icon-components.vue?vue&type=script&lang=js"
export * from "./icon-components.vue?vue&type=script&lang=js"

import "./icon-components.vue?vue&type=style&index=0&id=79febd48&lang=css"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__